export const DAILY = "Daily";
export const LIST = "List";
export const MONTHLY = "Monthly";
export const PAYCODE_SIDE_PANEL = "PaycodeSidePanel";
export const SIDE_PANEL = "SidePanel";
